import { render, staticRenderFns } from "./PaymentRegister.vue?vue&type=template&id=d2e64cf6&"
import script from "./PaymentRegister.vue?vue&type=script&lang=js&"
export * from "./PaymentRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports